import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import {months_list} from "../../Shared/List";

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaFileExport } from "react-icons/fa"
import BackButton from '../../Shared/BackButton'

const ZeroReadingDetail = () => {
    const [errors, setErrors] = useState({})
    const [billed, setBilled] = useState([])
    const [title, setTitle] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const gridRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
                if (isNaN(params.node.id)) {
                    return "";
                }
                return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "PID",
            field: "previous_id",
            sortable: true,
            filter: true,
        },
        {
            headerName: "ID",
            field: "location_id",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Name",
            field: "full_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Village",
            field: "village_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Zone",
            field: "zone_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            filter: true,
        },
        {
            headerName: "MeterID",
            field: "serial_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "LockID",
            field: "lock_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Prev.Reading",
            field: "previous_reading",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Curr.Reading",
            field: "current_reading",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Bill",
            field: "debit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Since",
            field: "since",
            sortable: true,
            filter: 'agNumberColumnFilter',
            valueFormatter: params => Number(params.value),
            comparator: (valueA, valueB) => valueA - valueB
        },
    ], [])

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/billed/zero-reading-detail?year=${payload.year}&month=${payload.month}&collector_id=${payload.collector_id}`)

            setBilled(response?.data)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error?.response?.status === 403){
                toast.error(error?.response?.data?.detail || 'Forbidden');
                navigate('/');
            }else {
                toast.warning(error?.response?.data?.detail || 'Failed to load zero reading details')
            }
        }
    }

    useEffect(() => {

        if (location.state){
            const {payload} = location.state

            fetchData({
                year: payload.year,
                month: payload.month,
                collector_id: payload.collector_id,
            })
            setTitle(`${payload.collector_name}, ${months_list[payload.month - 1].name} - ${payload.year} Zero Reading Details`)

        }
    }, [])

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <form>
            <div className="row">
                <div className="col-md-6">
                    <BackButton
                        to="/zero-reading-summary"
                        state={{ year: location.state?.payload?.year, month: location.state?.payload?.month }}
                        label="Back to Summary"
                    />
                </div>
                <div className="col-md-6">
                    <button onClick={()=>onExportClick()} className="btn btn-success" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}

                            rowData={billed}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}

                            pagination={false}
                            onGridReady={onGridReady}

                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}


                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
      <br/>
    </>
  )
}

export default ZeroReadingDetail
